export default "__VITE_ASSET__VQ1UARca__"